<template>
  <div class="modal fade" id="payReceiptView">
    <div class="modal-dialog modal-default">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            <button @click="printReceiptView()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
        </div>
        <div class="modal-body" id="printReceiptView">
            <div class="row printing" v-if="seeRecord">
              <div class="col-md-12">
                <!-- Profile Image -->
                <div class="card card-primary card-outline">
                  <div class="card-body box-profile">
                    <p class="text-bold text-center">{{getCompanyRecord.companyName}} <br> Payment Receipt</p> 
                    <table class="table table-condensed center">
                      <thead>
                        <tr v-if="seeRecord.branch">
                        <td>Branch</td>
                        <td>{{seeRecord.branch.name}}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="seeRecord.received_by">
                          <td>Agent</td>
                          <td>{{seeRecord.received_by.name}} <span v-if="seeRecord.received_by.code">( {{seeRecord.received_by.code}} )</span></td>
                        </tr>
                        <tr>
                          <td>Receipt Date</td>
                          <td>{{seeRecord.paymentDate}}</td>
                        </tr>
                        <tr>
                          <td>Receipt No.</td>
                          <td>{{seeRecord.id}}</td>
                        </tr>
                        <tr v-if ="seeRecord.type">
                          <td>Type</td>
                          <td v-if="seeRecord.type === 'panulty'">penalty</td>
                          <td v-else>{{seeRecord.type}}</td>
                        </tr>
                        <tr v-if="seeRecord.member_loan_plan">
                          <td>Loan Id</td>
                          <td>{{seeRecord.member_loan_plan.applicationNo}}</td>
                        </tr>
                        <tr v-if="seeRecord.member">
                          <td>Member</td>
                          <td>{{seeRecord.member.name}} <span v-if="seeRecord.member.code">( {{seeRecord.member.code}} )</span></td>
                        </tr>
                        <tr>
                          <td>Paid Amount</td>
                          <td>{{seeRecord.amt}}</td>
                        </tr>
                        <tr v-if="seeRecord.branch_ledger">
                          <td>Payment Mode</td>
                          <td>{{seeRecord.branch_ledger.ledger.name}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="text-bold">Note: This is a computer‐generated document. No signature is required</p>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!-- /.col -->
            </div>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Printd } from 'printd'
export default {
  name: 'emivoucherentry',
  props: ['seeRecord', 'getCompanyRecord'],
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      @page {
        size: A4;
        margin: 0;
      }
      
      p {
        font-weight: bold;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table th, table td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }`
    }
  },
  mounted () {

  },
  methods: {
    printReceiptView () {
      const d = new Printd()
      // Get HTML to print from element
      // const prtHtml = document.getElementById('printReceiptView').innerHTML

      // Get all stylesheets HTML
      // let stylesHtml = ''
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML
      // }
      d.print(document.getElementById('printReceiptView'), [this.cssText])
      // Open the print window
      // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      // WinPrint.document.write(`<!DOCTYPE html>
      //   <html>
      //     <head>
      //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
      //         ${stylesHtml}
      //         <style type="text/css">
      //           table th, table td { border:1px solid #000; padding:0.5em; }
      //         </style>
      //     </head>
      //     <body>
      //         ${prtHtml}
      //     </body>
      //   </html>`)

      // WinPrint.document.close()
      // WinPrint.focus()
      // WinPrint.print()
      // WinPrint.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentReceipt.vue?23979814